import React from 'react';
import PropTypes from 'prop-types';
import { Snackbar } from '@mui/material';
import c from 'classnames';

import './_downScreenMessage.scss';

const DownScreenMessage = ({ open, message, error = false, onClose, duration = 2500 }) => {
  const errorClass = c('downScreen-message', { 'error': error });

  return (
    <Snackbar
      classes={{ root: errorClass }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
      autoHideDuration={duration}
      message={message}
      onClose={onClose}
    />
  );
};

DownScreenMessage.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  error: PropTypes.bool,
  onClose: PropTypes.func,
  duration: PropTypes.number
};

export default DownScreenMessage;
